export function splitStr(str = '', quote = /['"]/, separators = /[\t\n, ]/) {
  let quoteChar = null
  let word = ''
  const list = []

  for (let i = 0; i < str.length; i++) {
    const char = str.charAt(i)
    const gotQuote = !!char.match(quote)

    // beginning of quote
    if (gotQuote && !quoteChar) {
      quoteChar = char
      continue
    }

    // maybe end of quote
    if (gotQuote && quoteChar === char) {
      // quote character is a literal character
      if (str.charAt(i + 1) === quoteChar) {
        // so include it in word
        word += quoteChar
        // skip over next character
        i += 1
      } else {
        // otherwise this is the closing of the quote
        quoteChar = null

        // do not finish word
        // if there isn't a separator then we join "touching" words
      }

      // in both cases move on
      continue
    }

    const gotSeparator = !!char.match(separators)
    // found separator outside quote
    if (!quoteChar && gotSeparator) {
      // finish word if it contains characters
      if (word) {
        list.push(word)
        word = ''
      }

      continue
    }

    word += char
  }

  // remaining word is final word
  if (word) {
    list.push(word)
  }

  return list
}
